export default {
    collect_success: 'Successful collection',
    cancel_collect_success: 'Cancelled',
    live_no: 'None',
    live_end: 'Over',
    introduction: 'Description',
    reserve: 'Appointment',
    cancel_reserve: 'Cancel',
};
